import Joi from 'joi';

/**
 * Schema for leased filebox record validation.
 */
export const leaseFileboxSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
